import { ReactNode } from "react";
import { ExternalToast, toast } from "sonner";

type ToastType = "success" | "error" | "warning" | "info";

const toastMap: Record<ToastType, typeof toast.success> = {
  success: toast.success,
  error: toast.error,
  warning: toast.warning,
  info: toast.info,
};

export const customToast = Object.fromEntries(
  Object.entries(toastMap).map(([type, fn]) => [
    type === "warning" ? "warn" : type, // keep our original API
    (message: string, data?: ExternalToast, id?: string): ReactNode =>
      fn(message, {
        toasterId: "global",
        id: id ?? message,
        ...data,
      }),
  ]),
) as {
  success: (message: string, data?: ExternalToast, id?: string) => ReactNode;
  error: (message: string, data?: ExternalToast) => ReactNode;
  warn: (message: string, data?: ExternalToast) => ReactNode;
  info: (message: string, data?: ExternalToast) => ReactNode;
};
